export const MAP_NEARBY_STORES_FIRST = 64
export const NEARBY_STORES_POI_FIRST = 12
export const NEARBY_LOCKERS_FIRST = 15
export const FEATURES_POIS_COUNT = 2
export const MAX_STORE_ITEM_TO_DISPLAY = 12
export const MAX_POIS_TO_DISPLAY = 10
export const MAX_STORES_PER_GRID = 9

/* Radius within which we consider a store to belong to a POI */
export const MAX_DISTANCE_POI_STORES = 2500 // in meters

/** Link count and structured data considerations:
 *
 * MAP_NEARBY_STORES_FIRST only used for Map pins
 * Current store limits per section:
 * - Main city stores: up to 12 stores
 * - Featured POI 1: up to 12 stores
 * - Featured POI 2: up to 12 stores (with FEATURES_POIS_COUNT = 2)
 * - Lockers: up to 12 stores
 * - 24/7 stores: filtered from main city stores could be MAX of MAX_STORE_ITEM_TO_DISPLAY
 * Maximum store links: ~60 store links (if all sections are displayed to MAX)
 *
 * Additional page links:
 * - Navigation/Header links
 * - Footer links
 * - POI links
 * - Utility links
 *
 * SEO considerations:
 * 1. Internal links: aim to keep total under ~100 per page
 **/
